import React from 'react';
// Revert to custom PdfFileIcon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilePowerpoint,
  faEnvelope,
  faFile,
} from '@fortawesome/pro-solid-svg-icons';
import PdfFileIcon from '../../_assets/svg/docs/PdfFileIcon.svg';
import MSWordIcon from '../../_assets/svg/docs/MSWordIcon.svg';
import MSExcelIcon from '../../_assets/svg/docs/MSExcelIcon.svg';
import CSVIcon from '../../_assets/svg/docs/CSVIcon.svg';
import JPGIcon from '../../_assets/svg/docs/JPGIcon.svg';
import PNGIcon from '../../_assets/svg/docs/PNGIcon.svg';
import GIFIcon from '../../_assets/svg/docs/GIFIcon.svg';

export const useFileTypeIcons = (
  extension = '',
  style: React.CSSProperties = {
    height: '2rem',
    width: '2rem',
    marginRight: '0.5rem',
  },
  fileName = ''
) => {
  // Helper function to extract extension from filename
  const getExtensionFromFileName = (filename: string): string => {
    const lastDotIndex = filename.lastIndexOf('.');
    return lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : '';
  };

  // Use the provided extension, or fall back to extracting from filename
  const effectiveExtension = extension || getExtensionFromFileName(fileName);

  // Each icon defaults its `<title>` to its own component name, which the
  // browser then shows as the hover tooltip -- every PDF row in the documents
  // grids read "PdfFileIcon" (FIR-21146). The document's own name is what a
  // reader wants there; the bare extension is the next best thing when the
  // caller only knows the type.
  const title = fileName || effectiveExtension.toUpperCase();

  switch (effectiveExtension.toLowerCase()) {
    case 'pdf':
      return <PdfFileIcon style={style} title={title} />;
    case 'doc':
    case 'docx':
      return <MSWordIcon style={style} title={title} />;
    case 'xls':
    case 'xlsx':
      return <MSExcelIcon style={style} title={title} />;
    case 'csv':
      return <CSVIcon style={style} title={title} />;
    case 'png':
      return <PNGIcon style={style} title={title} />;
    case 'jpg':
    case 'jpeg':
      return <JPGIcon style={style} title={title} />;
    case 'gif':
      return <GIFIcon style={style} title={title} />;
    case 'ppt':
    case 'pptx':
      return (
        <FontAwesomeIcon
          style={style as any}
          size="lg"
          icon={faFilePowerpoint}
          title={title}
        />
      );
    case 'eml':
      return (
        <FontAwesomeIcon
          style={style as any}
          size="lg"
          icon={faEnvelope}
          title={title}
        />
      );
    default:
      return (
        <FontAwesomeIcon
          style={style as any}
          size="lg"
          icon={faFile}
          title={title}
        />
      );
  }
};
